var render = function () {
  var _vm$localEstimate$doc, _vm$report;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', {
    attrs: {
      "color": "grey lighten-4"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "dense": "",
      "align": "start"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('m-text-field', {
    attrs: {
      "label": _vm.$t('components.PartnerReportDetail.repair.PartnerReportCostEstimateCard.number'),
      "readonly": "",
      "hide-details": ""
    },
    model: {
      value: _vm.localEstimate.number,
      callback: function callback($$v) {
        _vm.$set(_vm.localEstimate, "number", $$v);
      },
      expression: "localEstimate.number"
    }
  })], 1), _vm.canReadRepairEstimate ? _c('v-col', {
    staticClass: "d-flex justify-end align-start"
  }, [_c('div', [_vm.localEstimate.status === _vm.RequestStatusEnum.DRAFT && _vm.localEstimate.lastSharedContent ? _c('v-btn', {
    attrs: {
      "outlined": "",
      "small": ""
    },
    on: {
      "click": function click($event) {
        _vm.isSendDialog = true;
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "dark": ""
    }
  }, [_vm._v(" mdi-send-variant-outline ")]), _vm._v(" " + _vm._s(_vm.$t("submit")) + " ")], 1) : _vm._e(), _vm.canUpdateRepairEstimate ? _c('m-icon-button', {
    staticClass: "ml-2",
    attrs: {
      "outlined": "",
      "small": ""
    },
    on: {
      "click": function click() {
        return _vm.openUpdateDialog();
      }
    }
  }) : _vm._e(), _vm.canDeleteRepairEstimate ? _c('m-icon-button', {
    staticClass: "ml-2",
    attrs: {
      "icon": "mdi-trash-can",
      "outlined": "",
      "small": ""
    },
    on: {
      "click": function click() {
        return _vm.openDeleteDialog();
      }
    }
  }) : _vm._e(), _vm.canShareContent && !_vm.hideSharingLink ? _c('m-icon-button', {
    staticClass: "ml-2",
    attrs: {
      "icon": "mdi-link-variant",
      "small": "",
      "outlined": "",
      "disabled": !_vm.localEstimate.lastSharedContent
    },
    on: {
      "click": function click() {
        return _vm.sharedContentSideCardItem = _vm.localEstimate.lastSharedContent;
      }
    }
  }) : _vm._e(), !_vm.hideGoToDetail ? _c('m-icon-button', {
    staticClass: "ml-2",
    attrs: {
      "icon": "mdi-open-in-new",
      "outlined": "",
      "small": ""
    },
    on: {
      "click": function click() {
        return _vm.goToDetail();
      }
    }
  }) : _vm._e()], 1)]) : _vm._e()], 1), _c('v-row', {
    staticClass: "mb-2",
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('m-text-field', {
    attrs: {
      "label": _vm.$t('requested'),
      "readonly": "",
      "hide-details": ""
    },
    model: {
      value: _vm.localEstimate.timestamp.createdReadable,
      callback: function callback($$v) {
        _vm.$set(_vm.localEstimate.timestamp, "createdReadable", $$v);
      },
      expression: "localEstimate.timestamp.createdReadable"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('m-text-field', {
    attrs: {
      "label": _vm.$t('responded'),
      "readonly": "",
      "hide-details": ""
    },
    model: {
      value: _vm.localEstimate.respondedDate,
      callback: function callback($$v) {
        _vm.$set(_vm.localEstimate, "respondedDate", $$v);
      },
      expression: "localEstimate.respondedDate"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_vm.canReadRepairEstimate ? _c('m-text-field', {
    attrs: {
      "label": _vm.$t('components.PartnerReportDetail.repair.PartnerReportCostEstimateCard.date'),
      "readonly": "",
      "type": "date",
      "hide-details": ""
    },
    model: {
      value: _vm.localEstimate.dateFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.localEstimate, "dateFormable", $$v);
      },
      expression: "localEstimate.dateFormable"
    }
  }) : _vm._e()], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('m-select', {
    attrs: {
      "items": _vm.statusItems,
      "label": _vm.$t('components.PartnerReportDetail.repair.PartnerReportCostEstimateCard.status'),
      "chips": "",
      "readonly": "",
      "small-chips": "",
      "append-icon": '',
      "hide-details": ""
    },
    model: {
      value: _vm.localEstimate.status,
      callback: function callback($$v) {
        _vm.$set(_vm.localEstimate, "status", $$v);
      },
      expression: "localEstimate.status"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('m-text-field', {
    attrs: {
      "value": _vm.localEstimate.totalNet.toLocaleString('de-DE', {
        style: 'currency',
        currency: _vm.localEstimate.currency
      }),
      "label": _vm.$t('components.PartnerReportDetail.repair.PartnerReportCostEstimateCard.total'),
      "hide-details": "",
      "readonly": ""
    }
  })], 1)], 1)], 1), _vm.localEstimate.seller ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "mb-2 grey--text text--darken-2"
  }, [_vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.repair.PartnerReportCostEstimateCard.seller")) + " ")]), _c('invoice-party-sheet', {
    attrs: {
      "invoice-party": _vm.localEstimate.seller,
      "color": "white"
    }
  })], 1) : _vm._e(), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('m-select', {
    attrs: {
      "items": _vm.localEstimate.document ? [_vm.localEstimate.document] : [],
      "item-text": "name",
      "label": _vm.$t('common.nouns.appendix'),
      "readonly": "",
      "chips": "",
      "small-chips": "",
      "append-icon": '',
      "hide-details": ""
    },
    model: {
      value: _vm.localEstimate.document,
      callback: function callback($$v) {
        _vm.$set(_vm.localEstimate, "document", $$v);
      },
      expression: "localEstimate.document"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_vm.canUpdateRepairEstimate ? _c('select-assignees', {
    attrs: {
      "css": "width: 100%",
      "partnerId": _vm.localEstimate.partnerId,
      "outlined": false,
      "dense": false,
      "solo": false
    },
    on: {
      "input": _vm.onAssigneesUpdate,
      "added": _vm.onAssigneesAdded,
      "removed": _vm.onAssigneesRemoved
    },
    model: {
      value: _vm.localEstimate.assignees,
      callback: function callback($$v) {
        _vm.$set(_vm.localEstimate, "assignees", $$v);
      },
      expression: "localEstimate.assignees"
    }
  }) : _vm._e()], 1)], 1), _c('v-divider'), _c('m-expansion', {
    staticClass: "mb-1",
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.repair.PartnerReportCostEstimateCard.positions", {
          count: _vm.localEstimate.lineItems.length
        })))];
      },
      proxy: true
    }]),
    model: {
      value: _vm.showPositions,
      callback: function callback($$v) {
        _vm.showPositions = $$v;
      },
      expression: "showPositions"
    }
  }, [_c('v-sheet', {
    attrs: {
      "rounded": "",
      "color": "grey lighten-4 mb-2"
    }
  }, [_c('line-items-form', {
    attrs: {
      "value": _vm.localEstimate,
      "showQuantity": "",
      "readonly": ""
    }
  })], 1)], 1), _c('v-divider'), _c('m-expansion', {
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.repair.PartnerReportCostEstimateCard.documentId", {
          count: _vm.localEstimate.documentId ? 1 : 0
        })) + " ")];
      },
      proxy: true
    }]),
    model: {
      value: _vm.showDocument,
      callback: function callback($$v) {
        _vm.showDocument = $$v;
      },
      expression: "showDocument"
    }
  }, [_vm.localEstimate && _vm.localEstimate.isDocumentLoading ? _c('v-skeleton-loader', {
    attrs: {
      "type": "image"
    }
  }) : (_vm$localEstimate$doc = _vm.localEstimate.document) !== null && _vm$localEstimate$doc !== void 0 && _vm$localEstimate$doc.url ? _c('iframe', {
    attrs: {
      "src": _vm.localEstimate.document.url,
      "width": "100%",
      "height": "800px"
    }
  }) : _c('m-no-content', {
    attrs: {
      "icon": "mdi-file-document-outline",
      "text": _vm.$t('components.PartnerReportDetail.repair.PartnerReportCostEstimateCard.noDocumentText'),
      "color": "transparent"
    }
  })], 1), _c('partner-report-repair-estimate-update-dialog', {
    attrs: {
      "repairEstimate": _vm.localEstimate
    },
    on: {
      "update:repairEstimate": [function ($event) {
        _vm.localEstimate = $event;
      }, _vm.emitUpdateEstimate],
      "update:repair-estimate": function updateRepairEstimate($event) {
        _vm.localEstimate = $event;
      }
    },
    model: {
      value: _vm.isUpdateDialog,
      callback: function callback($$v) {
        _vm.isUpdateDialog = $$v;
      },
      expression: "isUpdateDialog"
    }
  }), _vm.report ? _c('report-appraisal-estimate-send-dialog', {
    attrs: {
      "repairEstimate": _vm.localEstimate,
      "report": _vm.report,
      "templateKey": _vm.TemplateKeyEnum.REQUEST_REPAIR_ESTIMATE_MAIL
    },
    on: {
      "update:repairEstimate": function updateRepairEstimate($event) {
        _vm.localEstimate = $event;
      },
      "update:repair-estimate": function updateRepairEstimate($event) {
        _vm.localEstimate = $event;
      }
    },
    model: {
      value: _vm.isSendDialog,
      callback: function callback($$v) {
        _vm.isSendDialog = $$v;
      },
      expression: "isSendDialog"
    }
  }) : _vm._e(), _vm.sharedContentSideCardItem ? _c('shared-content-side-card', {
    attrs: {
      "value": _vm.sharedContentSideCardItem,
      "referenceCategories": [_vm.ResourceEnum.DOCUMENT, _vm.ResourceEnum.RENTAL, _vm.ResourceEnum.APPRAISAL, _vm.ResourceEnum.REPAIR_ESTIMATE, _vm.ResourceEnum.CLEARANCE, _vm.ResourceEnum.CLEARANCE_APPROVAL],
      "suggested": (_vm$report = _vm.report) === null || _vm$report === void 0 ? void 0 : _vm$report.suggestedRefs,
      "hideSuggested": false,
      "filters": _vm.filters
    },
    on: {
      "close": function close($event) {
        _vm.sharedContentSideCardItem = null;
      }
    }
  }) : _vm._e(), _vm.isDeleteDialogActive ? _c('confirm-action-dialog', {
    attrs: {
      "isDialogActive": _vm.isDeleteDialogActive,
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "title": _vm.$t('partner.PartnerReportDetailChangeProgress.confirmDeleteTitle'),
      "rightColor": 'error',
      "rightLoading": _vm.isDeleteLoading
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isDeleteDialogActive = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isDeleteDialogActive = $event;
      },
      "close": function close($event) {
        _vm.isDeleteDialogActive = false;
      },
      "leftClick": function leftClick($event) {
        _vm.isDeleteDialogActive = false;
      },
      "rightClick": _vm.onDelete
    }
  }) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }